import React from 'react';
import EmojiIcon from '#web-components/components/Icons/EmojiIcon';
import type { EmojiIconProps } from '#web-components/components/Icons/EmojiIcon/EmojiIcon';
// https://emojipedia.org/page-facing-up/
export default function FolderIcon(props: Omit<EmojiIconProps, 'children'> = {}) {
  return (
    <EmojiIcon {...props}>📂</EmojiIcon>
  );
}
